// extracted by mini-css-extract-plugin
export var headerCell = "_1d-1";
export var loadingSpinnerContainer = "_1d-4";
export var loadingStateCell = "_1d-5";
export var rowWrapper = "_1d-3";
export var standaloneTable = "_1d-6";
export var table = "_1d-0";
export var white = "_1d-2";